import PropTypes from "prop-types";

import useFluencyWpm from "../../hooks/useFluencyWpm";
import { getReadingFluencyFromCustomData } from "../../const/fluencyCustomData";
import { getItemStem } from "../../utils/fluencyWpm/stems";

/**
 * Parent preview: same card as the teacher field — label, stem, then Your student result.
 * Hidden when empty. Value from gradingCriteriaDtos[].customData.readingFluency.
 */
const GuardianFluencyWpm = ({ selectedEpr, selectedSubject }) => {
    const criteria = (selectedEpr?.gradingCriteriaDtos || []).find((row) => row.subjectName === selectedSubject);
    const value = getReadingFluencyFromCustomData(criteria?.customData);
    const { items } = useFluencyWpm({
        gradeName: selectedEpr?.gradeName,
        subjectName: selectedSubject
    });
    const rows = items
        .map((item) => {
            const stem = getItemStem(item, selectedEpr?.gradeName);
            if (!value || !stem) return null;
            const result = typeof item.parentValue === "function" ? item.parentValue(value) : value;
            return {
                id: item.id,
                label: item.label,
                stem,
                resultLabel: item.parentResultLabel || "Your student",
                result
            };
        })
        .filter(Boolean);

    if (!rows.length) return null;

    return (
        <div data-testid="guardian-fluency-wpm">
            {rows.map((row) => (
                <div className="fluency-wpm-field" key={row.id}>
                    <div className="fluency-wpm-field__label">{row.label}</div>
                    <p className="fluency-wpm-field__stem">{row.stem}</p>
                    <div className="fluency-wpm-field__result">
                        <span className="fluency-wpm-field__result-label">{row.resultLabel}</span>
                        <span className="fluency-wpm-field__result-value">{row.result}</span>
                    </div>
                </div>
            ))}
        </div>
    );
};

GuardianFluencyWpm.propTypes = {
    selectedEpr: PropTypes.object,
    selectedSubject: PropTypes.string
};

GuardianFluencyWpm.defaultProps = {
    selectedEpr: null,
    selectedSubject: null
};

export default GuardianFluencyWpm;
